import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
  resource,
  signal,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { toSignal } from "@angular/core/rxjs-interop";
import { map, Subject, takeUntil } from "rxjs";

// local imports
import { CatalogConstants, CatalogStateService, DocumentModel, RoomContentModel } from "@app/catalog";
import { CatalogCommonConstants } from "@app/catalog-common";
import { BreadcrumbChangedMessage, BreadcrumbItemToggleMessage, IBreadcrumbItemModel, Messenger } from "@app/shared";
import { NavigationService } from "@app/core";

@Component({
  selector: "room-content-property",
  standalone: false,
  templateUrl: "./room-content-property.component.html",
  styleUrl: "./room-content-property.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomContentPropertyComponent implements OnInit, OnDestroy {
  private readonly destroying$ = new Subject<void>();
  private route = inject(ActivatedRoute);
  private catalogStateService = inject(CatalogStateService);
  
  

  public readonly is3DViewerEnable = signal(false);
  public catalogConstants = CatalogConstants;

  public roomContentId = toSignal(
     this.route.paramMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.ID)))
  );

  private departmentId = toSignal(
    this.route.queryParamMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.DEPARTMENT_ID)))
  );

  private programId = toSignal(
    this.route.queryParamMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.PROGRAM_ID)))
  );

  private projectId = toSignal(
    this.route.queryParamMap.pipe(map(params => params.get(CatalogCommonConstants.ROUTE_PARAMS.PROJECT_ID)))
  );

  public propertyResource = resource({
    request: () => ({
      id: this.roomContentId(),
      departmentId: this.departmentId(),
      programId: this.programId(),
      projectId: this.projectId(),
    }),
    loader: async ({ request }) => {
      const property = await this.catalogStateService.getRoomContentProperty(
        request.id,
        request.programId,
        request.projectId
      );

      if (property.documents) {
        const filteredDocuments = property.documents().filter(
          (doc: DocumentModel) => !doc.superseded()
        );
        property.documents.set(filteredDocuments);
      }

      return property;
    },
  });


  constructor(
    private navigationService: NavigationService
  ) {}

  public ngOnInit(): void {
    this.catalogStateService.initialize(this.route);

    this.route.queryParamMap.pipe(
      takeUntil(this.destroying$)
    ).subscribe((params) => {
      const roomContentId = params.get(CatalogCommonConstants.ROUTE_PARAMS.ROOM_CONTENT_ID);

      if (!roomContentId) {
        this.navigationService.back();
      }
    });
  }

  public open3DViewer(): void {
    this.is3DViewerEnable.set(true);
  }


  ngOnDestroy(): void {
    this.destroying$.next(undefined);
    this.destroying$.complete();
  }
}